import React from 'react';

/**
 * Жагсаалтын хуудаслалтын дундын компонент.
 * Бүх жагсаалттай хуудсанд ижил хэлбэрээр "Z-ээс A–B харуулж байна" +
 * Өмнөх/Дараах + хуудасны дугаар харуулна.
 *
 * page      — одоогийн хуудас (0-ээс эхэлнэ)
 * pageSize  — нэг хуудсанд харуулах мөрийн тоо
 * total     — нийт мөрийн тоо
 * count     — тухайн хуудсанд одоо харагдаж буй мөрийн тоо (сүүлийн хуудсыг зөв тооцох)
 */
export default function Pagination({
  page,
  pageSize,
  total,
  count,
  onChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  count?: number;
  onChange: (next: number) => void;
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const shown = count ?? Math.min(pageSize, Math.max(0, total - page * pageSize));
  const from = total === 0 ? 0 : page * pageSize + 1;
  const to = total === 0 ? 0 : page * pageSize + shown;

  const btn: React.CSSProperties = {
    padding: '6px 14px',
    border: '1.5px solid #dcdacf',
    borderRadius: 10,
    background: '#fff',
    color: '#2a3b32',
    fontSize: 14,
    cursor: 'pointer',
    fontWeight: 500,
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        marginTop: 16,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ fontSize: 14, color: '#5f6f66' }}>
        Нийт <strong>{total.toLocaleString()}</strong>-ээс{' '}
        <strong>{from.toLocaleString()}</strong>–<strong>{to.toLocaleString()}</strong> харуулж байна
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <button
          onClick={() => onChange(Math.max(0, page - 1))}
          disabled={page === 0}
          style={{ ...btn, opacity: page === 0 ? 0.4 : 1, cursor: page === 0 ? 'default' : 'pointer' }}
        >
          ← Өмнөх
        </button>
        <span style={{ padding: '6px 12px', fontSize: 14, color: '#5f6f66' }}>
          {page + 1} / {totalPages}
        </span>
        <button
          onClick={() => onChange(page + 1)}
          disabled={page + 1 >= totalPages}
          style={{ ...btn, opacity: page + 1 >= totalPages ? 0.4 : 1, cursor: page + 1 >= totalPages ? 'default' : 'pointer' }}
        >
          Дараах →
        </button>
      </div>
    </div>
  );
}
